// import React from "react";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Solutions from "../component/Solutions";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function SmartContract() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleItem = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };


    const splitTextToSpans = (text, className = "") =>
        [...text].map((char, index) => (
            <span className={`char ${className}`} key={`${char}-${index}`}>
                {char === " " ? "\u00A0" : char}
            </span>
        ));

    // light dark change image

    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const currentTheme =
            document.documentElement.getAttribute("data-theme") || "light";
        setTheme(currentTheme);

        const observer = new MutationObserver(() => {
            const newTheme =
                document.documentElement.getAttribute("data-theme") || "light";
            setTheme(newTheme);
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-theme"],
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Helmet>
                <title>Smart Contract Development Services | Blockcryp</title>
                <meta
                    name="description"
                    content="Build secure, efficient smart contracts with Blockcryp. We offer Ethereum, BNB, Solana, and custom smart contract development for DeFi, NFTs, and dApps."
                />
                <meta
                    name="keywords"
                    content="smart contract development, Ethereum smart contract developers, DeFi smart contract solutions, smart contract development company, Solana smart contract services, BNB smart contract development, blockchain contract automation, NFT smart contract development, custom smart contracts, Web3 smart contract experts"
                />
            </Helmet>
            {/* ---------- hreo section start ---------- */}
            <section className="space80">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 oreder-lg-1 order-2">
                            <motion.h1
                                className="heading_h1 fw-semibold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            > <span className="text-primary fw-bold"> Smart Contract </span> Development</motion.h1>
                            <motion.p
                                className="pera_txt"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Execute operations automatically and immutably with Smart Contract Development Services. We, as your reliable blockchain partner, provide precisely built smart contract solutions to turn your blockchain vision into a secure system that has in-built security protocols for smart contract vulnerabilities, ensuring a smooth and errorless workflow. Our innovative smart contract approach extends to various domains like NFTs, DApps, DeFi, and more.</motion.p>
                            <motion.p
                                className="pera_txt"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Writing the most secure and dependable smart contracts on Blockchain platforms such as Ethereum, EOS, Hyperledger, Tron, and more.</motion.p>
                            <motion.button
                                className="button theme_btn px-3 mt-4 mt-lg-0" type="submit"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Get Custom Contract</motion.button>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/smartcontract/smart_hero2.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/smartcontract/smart_hero1.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Smart Contract Development Services section start ---------- */}
            <section className="space80">
                <div className="container">
                    <div className="row justify-content-center g-4">
                        <div className="col-12 mb-5">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center"
                            >
                                <>
                                    {splitTextToSpans(" Our Smart Contract Development ")} <br className="d-md-block d-none" />
                                    {splitTextToSpans("Services", "text-primary")}
                                </>
                            </ScrollFloat>
                            {/* <h2 className="heading_h3 fw-semibold text-center">Our Smart Contract Development <span className="text-primary"> Services</span> </h2> */}
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Being a leading DeFi smart contract development company, Blockcryp helps enterprises achieve business automation by providing<br className="d-md-block d-none" />  them with advanced smart contract development services.
                            </motion.p>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className="col-xl-3 col-md-6">
                            <motion.div
                                className="token_card text-left"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/smartcontract/service1-dark.svg"
                                            : "assets/images/smartcontract/service1-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 class="heading_h5 fw-bold">Architecture</h5>
                                <p className="">Our DeFi smart contract development team follows resilient architecture practices, enhanced with AI-driven modeling and simulation techniques to ensure optimal code quality, predictability, and adaptability.</p>
                            </motion.div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <motion.div
                                className="token_card text-left"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/smartcontract/service2-dark.svg"
                                            : "assets/images/smartcontract/service2-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 class="heading_h5 fw-bold">AI-Driven</h5>
                                <p className="mb-0">We develop state-of-the-art, self-executing custom smart contracts enriched with advanced features while leveraging AI-coded logic to enhance automation, adaptability, and industry-specific performance across a wide range of sectors.</p>
                            </motion.div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <motion.div
                                className="token_card text-left"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/smartcontract/service3-dark.svg"
                                            : "assets/images/smartcontract/service3-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 class="heading_h5 fw-bold">Audit</h5>
                                <p>We offer AI-based smart contract auditing services to help businesses identify, rectify, and secure smart contract code from the ground up with greater precision and speed.</p>
                            </motion.div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <motion.div
                                className="token_card text-left"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/smartcontract/service4-dark.svg"
                                            : "assets/images/smartcontract/service4-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 class="heading_h5 fw-bold">Optimization</h5>
                                <p>Our certified smart contract development service providers use advanced AI optimization techniques that not only lower the average gas fee but also reduce the requirements of computational resources.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Smart Contract Development Solutions section start ---------- */}
            <section className="space60">
                <div className="container">
                    <ScrollFloat
                        animationDuration={1}
                        ease="back.inOut(2)"
                        scrollStart="center bottom+=50%"
                        scrollEnd="bottom bottom-=40%"
                        stagger={0.09}
                        textClassName="heading_h3 fw-semibold text-center mb-5"
                    >
                        <>
                            {splitTextToSpans("Explore Our Dynamic ", "")}
                            {splitTextToSpans("Smart Contract", "text-primary fw-bold")}
                            <br className="d-md-block d-none" />
                            {splitTextToSpans(" Development Solutions", "text-primary")}
                        </>
                    </ScrollFloat>
                    {/* <h2 className="heading_h3 fw-bold text-center mb-5">Explore Our Dynamic <span className="text-primary">Smart Contract Development Solutions</span></h2> */}
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-bold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Smart Contract Solutions for DApp</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Web3 & Wallet Integration :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We build on-chain logic using Solidity and Rust to automate dApp functions like user roles, payments, access control, and ownership validation in secure and scalable smart contract environments that ensure seamless autonomous operations across decentralized ecosystems.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Cross-Platform Scalability :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our dApp contracts interact with IPFS and Arweave for decentralized file storage. Metadata, documents, and files are safely stored off-chain, while hashes and file links are recorded on-chain, ensuring full decentralization and verifiable ownership.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Decentralized Storage Support :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our smart contracts integrate with Web3.js, MetaMask, and other wallets to authenticate users, sign transactions, and enable token interactions. This setup ensures smooth, secure dApp access, efficient session control, and consistent cross-platform connectivity.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/smartcontract/app_soul111.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/smartcontract/app_soul11.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Token Smart Contract Solutions section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/smartcontract/app_soul222.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/smartcontract/app_soul22.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.h3
                                className="heading_h3 fw-bold mb-4"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Token Smart Contract Solutions</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Secure Code & Audits :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    All token smart contracts undergo static and dynamic testing, manual code reviews, and vulnerability scanning. Security is baked into the architecture, meeting industry compliance for fast, secure, and scalable token launches across chains.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Advanced Token Features :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Each token contract includes modular add-ons such as vesting schedules, burn mechanisms, transaction fees, and snapshot functions. These ensure utility, governance, and tokenomics features that adapt to business and protocol requirements instantly.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Token Standards Support :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We deliver ERC-20, BEP-20, and custom token contracts with functions like minting, burning, pausing, and transferring, enabling compliant and secure deployments on Ethereum, BNB Chain, and any EVM-compatible blockchain with full lifecycle control.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Smart Contract Development Solutions section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-bold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Smart Contract Solutions for DEX</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >AMM Pool Logic :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We develop smart contracts that enable AMM-based liquidity pools with functions for swaps, reserves, and pricing curves. Users can trade tokens without centralized control, enhancing liquidity and decentralized market functionality on-chain.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >DEX Order Book Engine :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our smart contracts manage order books to support limit and market orders, cancellations, and trade matching. Designed for performance, these contracts enable efficient trading on permissionless and decentralized exchange protocols.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Liquidity Mining Features :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Incentivize liquidity providers with contracts that calculate and distribute rewards per block. These contracts support staking, farming pools, and dynamic APR, promoting consistent liquidity and user participation within your DEX.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/smartcontract/app_soul333.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/smartcontract/app_soul33.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Smart Contract Solutions for NFT section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/smartcontract/app_soul444.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/smartcontract/app_soul44.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.h3
                                className="heading_h3 fw-bold mb-4"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Smart Contract Solutions for NFT</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >NFT Minting Engines :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our crypto payment gateway supports a wide range of cryptocurrencies like BTC, ETH, USDT, and more. Businesses can accept payments in multiple tokens, allowing global customers to pay conveniently and securely while simplifying cross-border transactions.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Marketplace Integration :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Each NFT contract is pre-configured to interact NFT platforms. This ensures instant compatibility for minting, listing, bidding, and ownership tracking across the decentralized NFT ecosystem.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Cross-Chain Deployment :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We deploy NFT smart contracts on Ethereum, Polygon, BNB Chain, and more using bridges and standards for cross-chain operability, ensuring broad market access and user interaction with minimal cost and delay.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Smart Contract for Digital Wallet section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-bold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Smart Contract for Digital Wallet</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Layer-2 Compatibility :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Optimized for Layer-2 chains like Optimism and zkSync, our wallet smart contracts reduce latency and gas fees while supporting real-time transfers and connectivity for scalable and efficient dApp integration.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Key Management Systems :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We provide secure on-chain smart contract wallets with features like social recovery, time-locked access, multisig control, and signer roles. These support biometric login, 2FA, and dynamic access levels for users.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Multi-Chain Token Transfers :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our wallet contracts support token swaps, multi-chain bridging, and transaction batching across Ethereum, Arbitrum, and BNB. Smart routing reduces gas and improves transaction speed for users in real time.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/smartcontract/app_soul555.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/smartcontract/app_soul55.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Smart Contract Consulting & Strategy section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/smartcontract/app_soul666.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/smartcontract/app_soul66.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <motion.h3
                                className="heading_h3 fw-bold mb-4"
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Smart Contract Consulting & Strategy</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >End-to-End Guidance :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    From ideation to deployment, we provide hands-on support including tokenomics, legal reviews, gas optimization, and integration strategies, enabling faster, safer, and smarter go-to-market for blockchain-based systems.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Architecture & Planning :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our experts help define smart contract architecture, platform selection, and feature planning. This ensures that your blockchain projects align with long-term business strategies and technical scalability from day one.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Blockchain Use-Case Analysis :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We assess your business requirements to identify blockchain use cases and develop strategies aligned with ROI goals, ensuring optimal tech adoption and operational transformation through tailored smart contract use.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Blockchain Networks section start ---------- */}
            <section className="space60 services">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-12 mt-0 mb-3">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center"
                            >
                                <>
                                    {splitTextToSpans("Smart Contract Development Across Leading ")}
                                    <br className="d-md-block d-none" />
                                    {splitTextToSpans("Blockchain Networks", "text-primary fw-bold")}
                                </>
                            </ScrollFloat>
                            {/* <h2 className="heading_h3 fw-semibold text-center">Smart Contract Development Across Leading <span className="text-primary fw-bold"> <br className="d-md-block d-none" /> Blockchain Networks </span></h2> */}
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Whether it’s Tron or Hyperledger, our multidisciplinary team is capable of developing and deploying smart contracts <br className="d-md-block d-none" /> on renowned Blockchain networks.</motion.p>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/smartcontract/network1-dark.svg"
                                            : "assets/images/smartcontract/network1-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Ethereum</h5>
                                <p>Blockcryp leverages a powerful blend of technical expertise, AI-driven logic, and design-thinking methodologies to deliver intelligent and secure Ethereum smart contract development solutions that power dynamic dApps and enterprise use cases.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/smartcontract/network2-dark.svg"
                                            : "assets/images/smartcontract/network2-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Tron</h5>
                                <p>We offer robust TRON smart contract development services that combine blockchain efficiency with AI-enhanced automation while enabling businesses to build scalable, decentralized solutions for content sharing, gaming, and high-throughput environments.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/smartcontract/network3-dark.svg"
                                            : "assets/images/smartcontract/network3-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Hyperledger</h5>
                                <p>Our expert developers craft secure and modular smart contracts on Hyperledger frameworks and integrate AI capabilities required to meet enterprise-grade demands in supply chain, finance, and identity management with absolute precision.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/smartcontract/network4-dark.svg"
                                            : "assets/images/smartcontract/network4-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Binance</h5>
                                <p>Blockcryp delivers precision-engineered BSC smart contracts featuring automated asset management and AI-powered analytics, tailored for businesses seeking scalable and cost-efficient solutions through Binance smart contract development services.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/smartcontract/network5-dark.svg"
                                            : "assets/images/smartcontract/network5-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">EOS</h5>
                                <p>We develop highly functional EOS smart contracts to fuel next-generation dApps. By embedding AI where applicable, our solutions offer rapid execution, seamless scalability, and smarter decision-making aligned with evolving user demands.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="token_card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/smartcontract/network6-dark.svg"
                                            : "assets/images/smartcontract/network6-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Polkadot</h5>
                                <p>Blockcryp builds intelligent smart contracts on the Polkadot blockchain while harnessing its unique interoperability and parachain architecture. AI integration enhances cross-chain automation and contract adaptability for diverse, multi-network ecosystems.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- faq section start ---------- */}
            <section className="space80">
                <div className="container">
                    <h2 className="heading_h3 fw-bold mb-4">Frequently Asked Questions</h2>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion">
                                <div className={`accordion__item ${activeIndex === 0 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(0)}>
                                        <span className="text_20 pe-4">
                                            1. What is the future of smart contracts?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            The future of smart contracts lies in mainstream adoption across industries, enabling automated, secure, and trustless transactions. With growing blockchain integration, smart contracts will power decentralized apps, digital governance, finance, and real-world business processes efficiently and transparently.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 1 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(1)}>
                                        <span className="text_20 pe-4">
                                            2. What’s included in smart contract audits?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Smart contract audits involve reviewing code for security vulnerabilities, gas inefficiencies, and logic errors. Auditors run simulations, perform manual and automated checks, and provide a detailed vulnerability report. The goal is to ensure the contract is secure, bug-free, efficient, and ready for mainnet deployment.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 2 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(2)}>
                                        <span className="text_20 pe-4">
                                            3. How do smart contracts work in blockchain?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Smart contracts are self-executing pieces of code stored on a blockchain. They run automatically when predetermined conditions are met, eliminating intermediaries. Once deployed, they ensure transparent, tamper-proof, and secure transactions across decentralized ecosystems such as DeFi, NFTs, supply chains, and enterprise applications.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 3 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(3)}>
                                        <span className="text_20 pe-4">
                                            4. How much does a smart contract developer cost?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            The cost of hiring a smart contract developer depends on the platform, project complexity, and expertise. Typically, hourly rates range between $50–$200, while complete projects may cost from $5,000 to over $25,000, including development, testing, deployment, and ongoing support if required.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 4 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 " onClick={() => toggleItem(4)}>
                                        <span className="text_20 pe-4">
                                            5. What is the best smart contract development platform?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Ethereum is widely regarded as the best platform for smart contract development due to its robust ecosystem, security, and developer support. However, alternatives like Binance Smart Chain, Polygon, and Solana are also popular for their scalability, low fees, and suitability for various blockchain use cases.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Solutions />
        </>
    );
}
